<template>
  <v-dialog v-model="modal.show" width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>{{modal.title}}</v-card-title>
      <v-card-text>
        <p>{{modal.content}}</p>

        <p v-if="modal.type == 'url'">
          <v-text-field :value="modal.url" ref="textToCopy"></v-text-field>
          <v-btn @click="copyText">
            <v-icon>mdi-clipboard</v-icon>
            {{$t('app.copy')}}
          </v-btn>
        </p>

        <p v-if="modal.type == 'password'">
          <v-col>
            {{error}}
            <v-text-field
              v-model="password"
              type="password"
              :label="$t('app.invoice_password')"
              v-on:keyup="validatePassword"
              ref="password"
            ></v-text-field>
          </v-col>
        </p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="modal.show = false">{{$t('app.close')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState,mapActions } from "vuex";

export default {
  name: "GenericModal",
  computed: {
    ...mapState(["modal","invoice"])
  },
  components: {},
  data() {
    return {
      password: "",
      error :""
    };
  },
  methods: {
      ...mapActions(["updateInvoice"]),
    validatePassword(e) {
      if (e.keyCode === 13) {
       let id =  this.$route.params.id
        window.axios
         .get(process.env.VUE_APP_CLOUD_FUNCTIONS_BASE_URL+"checkPassword?id="+id+"&password="+this.password)
          .then(response => {
            if(response.status == 200){
                this.updateInvoice(response.data.invoice)
               this.modal.show = false
             
            }else{
              //
                this.error = this.$t('app.wrong_password')
            }
          });
      }
    },
    copyText() {
      let textToCopy = this.$refs.textToCopy.$el.querySelector("input");
      textToCopy.select();
      document.execCommand("copy");
    }
  }
};
</script>

<style scoped>
</style>